//https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file
let fileTypes = ['text/plain', 'text/csv', 'application/vnd.ms-excel'];

let documentFileTypes = [
  'image/jpeg',
  'image/jpeg',
  'image/png',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/pdf',
];

let imageFileTypes = ['image/jpeg', 'image/jpeg', 'image/png', 'image/svg+xml'];

export const validFileType = (file: any) => {
  for (let i = 0; i < fileTypes.length; i++) {
    if (file.type === fileTypes[i]) {
      return true;
    }
  }

  return false;
};

export const validClaimFileType = (file: any) => {
  for (let i = 0; i < documentFileTypes.length; i++) {
    if (file.type === documentFileTypes[i]) {
      return true;
    }
  }

  return false;
};

export const validDocumentFileType = (file: any) => {
  for (let i = 0; i < imageFileTypes.length; i++) {
    if (file.type === imageFileTypes[i]) {
      return true;
    }
  }

  return false;
};

export const returnFileSize = (sizeInBytes: number) => {
  if (sizeInBytes < 1024) {
    return sizeInBytes + 'bytes';
  } else if (sizeInBytes >= 1024 && sizeInBytes < 1048576) {
    return (sizeInBytes / 1024).toFixed(1) + 'KB';
  } else if (sizeInBytes >= 1048576) {
    return (sizeInBytes / 1048576).toFixed(1) + 'MB';
  }
};

export type allFileTypes = '.CSV' | '.TXT' | '.XLSX' | '.PDF' | '.DOCX' | '.JPG' | '.PNG';

const getFileType = (fileType: allFileTypes) => {
  switch (fileType) {
    case '.CSV':
      return ['text/csv', 'application/vnd.ms-excel'];
    case '.TXT':
      return ['text/plain'];
    case '.XLSX':
      return [
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      ];
    case '.PDF':
      return ['application/pdf'];
    case '.DOCX':
      return [
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      ];
    case '.JPG':
      return ['image/jpeg'];
    case '.PNG':
      return ['image/png'];
    default:
      return [];
  }
};

export const isFileTypeAllowed = (file: File, fileTypeAllowed: allFileTypes[]) => {
  // //foreach allowed type, use getFileType to get the file type and add to an array
  const fileTypes = fileTypeAllowed.map(getFileType).flat();

  //check if the file type is in the fileTypes array
  return fileTypes.some((type) => type === file.type);
};
